import React from "react";
import OtpInput from "react-otp-input";
import "./otpInputBox.scss";

const OtpInputBox = ({ otp, setOtp }) => {
  return (
    <div className="otp-container">
      <OtpInput
        value={otp}
        onChange={setOtp}
        numInputs={6}
        renderSeparator={<span>-</span>}
        renderInput={(props) => <input {...props} className="otp-input" />}
      />
    </div>
  );
};

export default OtpInputBox;
